// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1Thj1","content":"styles_content__3_kXd","checkbox":"styles_checkbox__3JW3B","checkboxLabel":"styles_checkboxLabel__2pUiz"};